<template>
    <div class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm margem">
            <div class="alinha-centro m-b">
                <h2>
                    Todas as tarefas dos elementos abaixo foram concluídas
                </h2>
            </div>
            <table class="tabela">
                <tbody>
                    <tr>
                        <th>Código</th>
                        <th>Nome</th>
                        <th>Fim Previsto</th>
                        <th>Status</th>
                        <th>Setor Demandante</th>
                        <th>Setor Destinatário</th>
                        <th></th>
                    </tr>
                    <tr v-for="p in protocolos" :key="p.id">
                        <td>{{ p.codigo }}</td>
                        <td>{{ p.nome }}</td>
                        <td><input type="date" readonly :value="p.dtFimPrevisto"></td>
                        <td>{{ p.status }}</td>
                        <td>{{ p.setor?.nome }}</td>
                        <td>{{ p.setorDestinatario?.nome }}</td>
                        <td>
                            <button class="acao-secundaria bg-sucesso" :disabled="p.status == 'Concluído'"
                                @click="atualizarProtocolo(p.id), p.status = 'Concluído'">
                                Encerrar
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="submit direita">
                <button @click="$emit('fechar')">Fechar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { sso } from "roboflex-thalamus-sso-lib";
import serviceProtocolo from "@/services/serviceProtocolo";

export default {
    name: "ModalProtocolosFinalizar",

    props: {
        protocolos: {
            type: Array,
            required: true,
        },
    },

    methods: {
        atualizarProtocolo(id) {
            const usuarioId = sso.getUsuarioLogado()?.id;
            serviceProtocolo.editarProtocolo(id, "status", "Concluído", usuarioId);
        },
    },
};
</script>

<style scoped>
.jm {
    min-width: 50vw;
    max-width: 80vw;
    max-height: 80vh;
    overflow: auto;
}

td {
    button {
        background-color: var(--cor-sucesso);
    }
}
</style>